<div class="profile-picture" [style.width.px]="imgSize" [style.height.px]="imgSize">
  <img #pic (load)="onLoad()" [src]="avatarUrl" [style.width.%]="imgRatio" />
</div>